import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Link, useHistory } from 'react-router-dom';
import { formataDinheiro } from '../../util/formatacao';
import { ButtonGroup, Row, Col, Container, Button } from 'react-bootstrap';


import Rodape from '../../components/rodape';
import Navbar from '../../components/navbar';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import DataGrid from '../../components/datagrid';
import Icone from '../../components/Icone';
import Sidebar from './components/sidebar';
import MainContent from './components/mainContent';

library.add(fas);


export default function CapitaoRocha(props) {

    return (
        <>
            <Navbar />
            <div className="app-container">
                <MainContent />
            </div>
        </>
    );
}
